import { EQUAL, GREATER, GREATER_OR_EQUAL, IN_RANGE, LESS, LESS_OR_EQUAL, NOT_EQUAL } from '../../../converters/crmSearch/FilterCRMSearchOperatorTypesType';
import { InRange, Equal, Greater, GreaterOrEqual, Less, LessOrEqual, NotEqual } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { isNumberDurationQuickFilterOperatorType } from '../../../types/quickFilters/NumberDurationQuickFilterOperatorType';
export const NUMBER_DURATION_TWO_VALUE_OPERATORS = [IN_RANGE];
export const NUMBER_DURATION_DEFAULT_OPERATOR = IN_RANGE;
const operatorTypeToOperator = {
  [IN_RANGE]: InRange,
  [EQUAL]: Equal,
  [NOT_EQUAL]: NotEqual,
  [LESS]: Less,
  [LESS_OR_EQUAL]: LessOrEqual,
  [GREATER]: Greater,
  [GREATER_OR_EQUAL]: GreaterOrEqual
};
export const mapOperatorTypeToOperator = operatorType => operatorTypeToOperator[operatorType];
export const mapOperatorNameToOperatorType = operatorName => {
  for (const key of Object.keys(operatorTypeToOperator)) {
    if (isNumberDurationQuickFilterOperatorType(key) && operatorTypeToOperator[key].toString() === operatorName) {
      return key;
    }
  }
  return NUMBER_DURATION_DEFAULT_OPERATOR;
};
export const betweenOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.between',
  symbol: '―',
  value: IN_RANGE
});
export const equalOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.equal',
  symbol: '=',
  value: EQUAL
});
export const notEqualOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.notEqual',
  symbol: '≠',
  value: NOT_EQUAL
});
export const lessOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.less',
  symbol: '<',
  value: LESS
});
export const lessOrEqualOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.lessOrEqual',
  symbol: '≤',
  value: LESS_OR_EQUAL
});
export const greaterOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.greater',
  symbol: '>',
  value: GREATER
});
export const greaterOrEqualOption = Object.freeze({
  langToken: 'customerDataFiltersUI.quickFiltersBar.number.operatorHelp.greaterOrEqual',
  symbol: '≥',
  value: GREATER_OR_EQUAL
});
export const numberDurationOperatorOptions = [betweenOption, equalOption, notEqualOption, lessOption, lessOrEqualOption, greaterOption, greaterOrEqualOption];
export const mapOperatorToOperatorOption = {
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [InRange]: betweenOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [Equal]: equalOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [NotEqual]: notEqualOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [Less]: lessOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [LessOrEqual]: lessOrEqualOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [Greater]: greaterOption,
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [GreaterOrEqual]: greaterOrEqualOption
};